<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<div class="image_containerf" id="fig1">
<img alt="images" src="images/fviii_01.jpg"/>
<p class="caption">Map detailing the travels of Ned Low from his initial mutiny in the Bay of Honduras in December 1721 until he was deposed as captain near Martinique in early 1724.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Map.vue?58e8493d